import React from "react";
import {
  Home,
  Library,
  Star,
  Monitor,
  SlidersHorizontal,
  BarChart2,
  Calendar,
  ListVideo,
  RotateCcw,
  Search,
  Play,
  Pause,
  Cast,
  Plus,
  ChevronRight,
  Lock,
  Check,
  Bell,
  Users,
  Sparkles,
  LogOut,
  Unplug,
  Archive,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

type IconName =
  | "home"
  | "library"
  | "star"
  | "cowatch"
  | "controls"
  | "chart"
  | "schedule"
  | "playlist"
  | "recap"
  | "search"
  | "play"
  | "pause"
  | "cast"
  | "plus"
  | "chev"
  | "lock"
  | "check"
  | "bell"
  | "family"
  | "sparkle"
  | "logout"
  | "unplug"
  | "archive";

type Props = { name: IconName; size?: number };

const ICON_MAP: Record<IconName, LucideIcon> = {
  home:     Home,
  library:  Library,
  star:     Star,
  cowatch:  Monitor,
  controls: SlidersHorizontal,
  chart:    BarChart2,
  schedule: Calendar,
  playlist: ListVideo,
  recap:    RotateCcw,
  search:   Search,
  play:     Play,
  pause:    Pause,
  cast:     Cast,
  plus:     Plus,
  chev:     ChevronRight,
  lock:     Lock,
  check:    Check,
  bell:     Bell,
  family:   Users,
  sparkle:  Sparkles,
  logout:   LogOut,
  unplug:   Unplug,
  archive:  Archive,
};

export function Icon({ name, size = 20 }: Props) {
  const IconComp = ICON_MAP[name];
  if (!IconComp) return null;
  return <IconComp size={size} strokeWidth={2} />;
}

export default Icon;
